﻿import React, { useEffect, useState } from "react";
import { IFrameWithLoading } from "../../../Components";
import { PointerEventsManager } from "../../../Managers";
import { PointerEventsProperty } from "csstype";

export const ODE: React.FunctionComponent = (): React.ReactElement => {
    const [pointerEvents, setPointerEvents] = useState<boolean>(true);

    const setPointerEventsProperty = (toggle: boolean): void => {
        setPointerEvents(toggle);
    };

    useEffect(() => {
        PointerEventsManager.registerWatcher(
            `odeWindow`,
            setPointerEventsProperty,
        );

        return (): void => {
            PointerEventsManager.deRegisterWatcher(`odeWindow`);
        };
    }, []);

    const pointerEventsProperty: PointerEventsProperty = pointerEvents
        ? `inherit`
        : `none`;

    return (
        <IFrameWithLoading
            pointerEventsProperty={pointerEventsProperty}
            src={`/Applications/DataExporter`}
            style={{
                border: `none`,
                height: 800,
                width: 750,
            }}
        />
    );
};
